export const maintenanceConstants = {
  CHECK_HEALTH_REQUEST: 'MAINTENANCE_CHECK_HEALTH_REQUEST',
  CHECK_HEALTH_SUCCESS: 'MAINTENANCE_CHECK_HEALTH_SUCCESS',
  CHECK_HEALTH_FAILURE: 'MAINTENANCE_CHECK_HEALTH_FAILURE',
};
